import { useEffect, useState } from "react";

export const useMobileBanner = () => {
    const [showBanner, setShowBanner] = useState<boolean>(false);

    useEffect(() => {
        const checkConditions = () => {
            const isMobile = window.innerWidth < 600;
            const isPortrait = window.matchMedia("(orientation: portrait)").matches;
            const alreadyClosed = sessionStorage.getItem("tipBannerClosed") === "true";

            setShowBanner(isMobile && isPortrait && !alreadyClosed);
        };

        checkConditions();

        const mql = window.matchMedia("(orientation: portrait)");
        window.addEventListener("resize", checkConditions);
        mql.addEventListener ? mql.addEventListener("change", checkConditions) : mql.addListener(checkConditions);

        return () => {
            window.removeEventListener("resize", checkConditions);
            mql.removeEventListener ? mql.removeEventListener("change", checkConditions) : mql.removeListener(checkConditions);
        };
    }, []);

    const closeBanner = () => {
        sessionStorage.setItem("tipBannerClosed", "true");
        setShowBanner(false);
    };

    return { showBanner, closeBanner };
};